package org.jetbrains.compose.web.css.properties

import org.jetbrains.compose.web.css.StyleScope

fun StyleScope.verticalAlign(value: String) {
    property("vertical-align", value)
}
